import { Flex } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaSave } from 'react-icons/fa'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { ModalBase } from '../../../../../components/ModalBase'

interface iModalProps {
  mesPersonalizado: { id: string, val?: number }
  mesesAbreviados: string[]
  isOpen: boolean
  onClose: () => void
  onConfirm: (mesNovo: { id: string, val?: number }) => void
}

export const ModalMesesPersonalizados: React.FC<iModalProps> = ({ isOpen, onConfirm, onClose, mesPersonalizado, mesesAbreviados }) => {
  const [Model, setModel] = useState<{ id: string, val?: number }>(mesPersonalizado)

  useEffect(() => {
    setModel(mesPersonalizado)
  }, [])

  return (
    <ModalBase
      Titulo={'Editar mês de valor previsto'}
      isOpen={isOpen}
      onClose={onClose}
      Width='60rem'
    >
      <Flex gap={'1rem'} w='100%' px={'1.5rem'} py={'1.5rem'} justifyContent={'center'}>
        {mesesAbreviados.map((m, i) => {
          return <Flex cursor={'pointer'} border={'1px solid var(--Azul)'} borderRadius={'.25rem'} p={'.325rem .875rem'} fontWeight={'600'} fontSize='14px' alignItems={'center'} justifyContent={'center'} _hover={{ bg: 'var(--Azul)', color: 'var(--c1)', boxShadow: 'var(--SombraBtns)', brightness: '1.07' }} bg={Model.val === (i + 1) ? 'var(--Azul)' : ''} color={Model.val === (i + 1) ? 'var(--c1)' : ''} onClick={() => setModel({ ...Model, val: i + 1 })}>
            {m}
          </Flex>
        })}
      </Flex>
      <Flex padding={'0 1rem 1rem 0'} justifyContent={'end'} gap={'.5rem'}>
        <ButtonCmp VarColor='c6' onClick={onClose}>Voltar</ButtonCmp>
        <ButtonCmp VarColor='Green2' onClick={() => onConfirm(Model)} isDisabled={Model.val === undefined || Model.val === null} leftIcon={<FaSave/>}>Salvar</ButtonCmp>
      </Flex>
    </ModalBase>
  )
}
